import { ValidationError } from '../../gs-core/common/models';
import { DocFormats } from './DocFormat';

export const MIN_FILE_SIZE = 10 * 1024;
export const MAX_FILE_SIZE = 25 * 1024 * 1024;
export const MAX_BATCH_FILE_COUNT = 100;

// Validate the file meta attributes but not the file contents
export const shallowValidateFile = (file: File) => {
  if (!file) {
    throw new ValidationError('Missing file');
  }

  if (file.size < MIN_FILE_SIZE) {
    throw new ValidationError('File is too small');
  }

  if (file.size > MAX_FILE_SIZE) {
    throw new ValidationError('File is too large');
  }

  const nameParts = file.name.split('.');

  if (nameParts.length < 2) {
    throw new ValidationError('Invalid file name');
  }

  const extension = nameParts[nameParts.length - 1];
  DocFormats.parse(extension);
};



// WEBPACK FOOTER //
// ./src/common/models/shallowValidateFile.ts